export default __webpack_public_path__ + "static/media/39g.721bbf30.svg";